"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.array.find");require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");

















































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { page: 1, rows: 10 }, //搜索表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      auditStatus: 0, //升级任务审核状态;1:已审核；0：未审核。
      upgradeId: 0, //升级任务id
      showDialog: false, //是否显示新增||编辑弹窗
      tableColumns: [{ prop: 'localeName', label: '界面语言' }, { prop: 'content', label: '更新内容' }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter }], //表格信息
      list: [], //表格数据
      localeForm: { id: 0, localeName: '', locale: '', content: '' }, //更新内容表单
      localeFormRule: { locale: [{ required: true, message: '请选择界面语言', trigger: ['blur', 'change'] }], content: [{ required: true, message: '请输入更新内容', trigger: ['blur', 'change'] }] }, //更新内容表单验证规则
      localeList: [] //语言列表
    };}, mounted: function mounted() {this.auditStatus = this.$route.params.auditStatus;this.upgradeId = this.$route.params.parentId;this.initPage();},

  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchUpdateContentList();
      this.fetchLocaleList();
    },

    /**
        * 获取更新内容列表
        */
    fetchUpdateContentList: function fetchUpdateContentList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      params.otaVersionJobId = this.upgradeId;
      this.getData('/api/faOtaVersionUpdateContent', params, function (res) {
        _this.list = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取语言列表
        */
    fetchLocaleList: function fetchLocaleList() {var _this2 = this;
      this.getData('/api/faDict/parentCode/locale', {}, function (res) {
        _this2.localeList = res;
      });
    },

    /**
        * 返回
        */
    onClickReturn: function onClickReturn() {
      this.$router.push('/ota/upgrade');
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.fetchUpdateContentList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.fetchUpdateContentList();
    },

    /**
        * 编辑
        */
    onClickUpdate: function onClickUpdate(row) {
      this.showDialog = true;
      this.$set(this.localeForm, 'id', row.id);
      this.$set(this.localeForm, 'locale', row.locale);
      this.$set(this.localeForm, 'localeName', row.localeName);
      this.$set(this.localeForm, 'content', row.content);
    },

    /**
        * 删除
        */
    onClickDelete: function onClickDelete(row) {var _this3 = this;
      this.$confirm('确定删除当前更新内容？', '提示', { type: 'warning' }).then(function (res) {
        //删除升级任务
        _this3.delData('/api/faOtaVersionUpdateContent/' + row.id, {}, function (res) {
          _this3.fetchUpdateContentList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗关闭
        */
    onDialogClose: function onDialogClose() {var _this4 = this;
      this.$nextTick(function () {
        Object.keys(_this4.localeForm).forEach(function (key) {
          _this4.$set(_this4.localeForm, key, key == 'id' ? 0 : '');
        });
        _this4.$refs.localeForm.clearValidate();
      });
      this.showDialog = false;
    },

    /**
        * 语言-change
        */
    onLocaleChange: function onLocaleChange(value) {
      var obj = this.localeList.find(function (item) {
        return item.value === value;
      });
      this.$set(this.localeForm, 'localeName', obj.name);
    },

    /**
        * 提交语言表单
        */
    onSubmitLocale: function onSubmitLocale() {var _this5 = this;
      this.$refs.localeForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this5.localeForm);
          params.otaVersionJobId = _this5.upgradeId;
          if (params.id) {
            //编辑
            _this5.postData('/api/faOtaVersionUpdateContent', params, function (res) {
              _this5.onDialogClose();
              _this5.fetchUpdateContentList();
            });
          } else {
            //新增
            delete params['id'];
            _this5.postData('/api/faOtaVersionUpdateContent', params, function (res) {
              _this5.onDialogClose();
              _this5.fetchUpdateContentList();
            });
          }
        }
      });
    } } };exports.default = _default;